import React, { useEffect, useState } from 'react';
import { Snowflake, Sun, Loader2, Send, Eye } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { adminAPI } from '../services/api';

const LABEL = { hiver: ['Passage à l\'hiver', 'clients ayant acheté des pneus été', Snowflake], ete: ['Retour de l\'été', 'clients ayant acheté des pneus hiver', Sun] };

// Admin › Paramètres : seasonal tyre reminder campaigns (auto each morning inside the window, manual send/preview here)
export const TyreSeasonPanel = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState('');
  const load = () => adminAPI.tyreSeasonPreview().then(setData).catch(() => setData({ error: true }));
  useEffect(() => { load(); }, []);

  const send = async (season, dryRun) => {
    if (!dryRun && !window.confirm(`Envoyer maintenant la relance « ${LABEL[season][0]} » à ${data.campaigns[season].targets} client(s) ? (un seul envoi par client et par saison)`)) return;
    setBusy(`${season}-${dryRun}`);
    try {
      const r = await adminAPI.tyreSeasonSend(season, dryRun);
      toast.success(dryRun ? `${r.targets} client(s) ciblé(s)` : `${r.sent} e-mail(s) envoyé(s)${r.errors?.length ? ` · ${r.errors.length} erreur(s)` : ''}`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Envoi impossible'); }
    finally { setBusy(''); }
  };

  if (!data || data.error) return null;
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 max-w-3xl mt-6" data-testid="tyre-season-panel">
      <div className="flex items-center gap-2 mb-1"><Snowflake size={20} className="text-sky-500" /><h2 className="font-semibold text-gray-900">Relance pneus saison</h2></div>
      <p className="text-sm text-gray-500 mb-4">Chaque matin pendant la fenêtre de campagne, les clients ayant acheté des pneus de la saison opposée reçoivent un e-mail avec leur dimension déjà pré-remplie dans la recherche (un envoi par client et par saison). Campagne active : <strong data-testid="tyre-season-active">{data.active ? LABEL[data.active][0] : 'aucune'}</strong> · {data.sent_this_year} envoi(s) cette année.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {Object.entries(data.campaigns).map(([season, c]) => {
          const [title, who, Icon] = LABEL[season];
          return (
            <div key={season} className={`border rounded-lg p-3 ${data.active === season ? 'border-sky-300 bg-sky-50/40' : 'border-gray-200'}`} data-testid={`tyre-season-${season}`}>
              <p className="font-medium text-gray-900 flex items-center gap-1.5"><Icon size={15} className={season === 'hiver' ? 'text-sky-600' : 'text-amber-500'} /> {title}</p>
              <p className="text-xs text-gray-500">Fenêtre {c.window} · {who}</p>
              <p className="text-sm text-gray-800 mt-1"><span className="font-semibold" data-testid={`tyre-season-${season}-targets`}>{c.targets}</span> client(s) à relancer</p>
              {c.sample?.length > 0 && <ul className="text-[11px] text-gray-500 mt-1">{c.sample.slice(0, 3).map((s, i) => <li key={i}>{s.email} — {s.sizes.join(', ')}</li>)}</ul>}
              <div className="flex gap-2 mt-2">
                <Button size="sm" variant="outline" onClick={() => send(season, true)} disabled={!!busy} data-testid={`tyre-season-${season}-preview`}>{busy === `${season}-true` ? <Loader2 size={12} className="animate-spin" /> : <Eye size={12} />} <span className="ml-1">Aperçu</span></Button>
                <Button size="sm" onClick={() => send(season, false)} disabled={!!busy || !c.targets} className="bg-[#1e3a5f] hover:bg-[#2d4a6f] text-white" data-testid={`tyre-season-${season}-send`}>{busy === `${season}-false` ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} />} <span className="ml-1">Envoyer maintenant</span></Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TyreSeasonPanel;
